import { Button } from "antd";

const LotteryVisibilityActions = ({
  visibility,
  status,
  setData,
  hasNumbers,
  setDraft,
}) => {
  if (visibility === "draft" && hasNumbers) {
    return (
      <Button
        type="primary"
        onClick={() => setData(true)}
        style={{ padding: "0px 20px" }}
      >
        Нийтлэх
      </Button>
    );
  }

  if (visibility === "public" && hasNumbers) {
    return (
      <>
        <Button
          // type="primary"
          // danger
          variant="dashed"
          color="danger"
          onClick={() => setDraft(true)}
          style={{ padding: "0px 20px" }}
        >
          Ноорог болгох
        </Button>
        {status === "upcoming" ? (
          <Button
            type="primary"
            onClick={() => setData(true)}
            style={{ padding: "0px 20px" }}
          >
             Идэвхтэй болгох
          </Button>
        ) : null}
      </>
    );
  }

  return null;
};

export { LotteryVisibilityActions };
